/**
 * 融科堂
 */

import Container from '@/containers';

const newsRouter = {
    path: '/news',
    component: Container,
    redirect: '/news/index',
    name: 'News',
    meta: {
        title: '融科堂'
    },
    children: [
        {
            path: 'index',
            component: () => import('@/views/news/index'),
            name: 'NewsIndex',
            meta: {
                title: '首页',
                showAddBtn:true
            }
        },
        {
            path: 'detail',
            component: () => import('@/views/news/detail'),
            name: 'NewsDetail',
            meta: {
                title: '首页',
                showAddBtn:true
            }
        }
    ]
};

export default newsRouter;